import { observable, action } from 'mobx';

export interface ITransaction {
    hasOrderableItems: number;
    hasPreOrderItemOnly: number;
    hasPreOrderItems: number;
    order: IOrder;
    trans_items_count: number;
}

export interface IOrderItem {
    ITEM_QUANTITY: number;
    formattedAppliedPrice: string;
    'prod.PROD_RGN_NAME': string;
    'sku.PRODUCT_SIZE': string;
    'sku.IMAGE_SMALL': string;
    'sku.SKU_BASE_ID': number;
}

export interface IOrder {
    SHIP_METHOD: number;
    items: IOrderItem[];
}

export class Transaction {
    @observable deliveryOption: number;

    @observable transaction: ITransaction;

    @action
    setDeliveryOption = (id: number): void => {
        this.deliveryOption = id;
    };

    @action
    setTransaction = (transaction: ITransaction): void => {
        this.transaction = transaction;
    };
}
